<template>
    <li v-if="category">
        <div class="product-category__header">
            <router-link tag="a" :to="to" :exact-active-class="_selecteds.includes(category._id) ? 'on' : 'off'" class="product-category__link" data-toggle="closed" exact>{{ category.name }}</router-link>
            <button v-show="(category.children || []).length" v-html="icon" class="product-category__expand" :class="{ on: _selecteds.includes(category._id) || show }" @click="toggle">{{ icon }}</button>
        </div>
        <transition name="accordion" v-on:before-enter="beforeEnter" v-on:enter="enter" v-on:after-enter="afterEnter" v-on:leave="leave">
            <div ref="sub" class="product-category__sub" v-show="_selecteds.includes(category._id) || show">
                <ul class="product-category__level">
                    <slot name="default" v-bind:event="{ beforeEnter, enter, beforeLeave, leave }"></slot>
                </ul>
            </div>
        </transition>
    </li>
</template>

<script>
export default {
    props: {
        _selecteds: Array,
        category: { type: Object, default: null },
        to: String,
    },
    data() {
        return {
            selected: false,
            show: false,
            icon: '<svg x="0px" y="0px" fill="currentColor" viewBox="0 0 9.7 6.4"><path class="st0" d="M4.8,6.4L0.3,1.7c-0.4-0.4-0.4-1,0-1.4c0.4-0.4,1-0.4,1.4,0l3.1,3.2L8,0.3c0.4-0.4,1-0.4,1.4,0c0.4,0.4,0.4,1,0,1.4L4.8,6.4z"/></svg>',
        };
    },
    methods: {
        toggle() {
            if (this.selected) this.selected = !this.selected;
            else this.show = !this.show;
        },
        beforeEnter(el) {
            el.style.height = "0";
        },
        enter(el) {
            el.style.height = el.scrollHeight + "px";
        },
        afterEnter(el) {
            el.style.height = "auto";
        },
        beforeLeave(el) {
            el.style.height = el.scrollHeight + "px";
        },
        leave(el) {
            el.style.height = getComputedStyle(el).height;

            // Force repaint to make sure the
            // animation is triggered correctly.
            getComputedStyle(el).height;

            requestAnimationFrame(() => {
                el.style.height = 0;
            });
        },
    },
    watch: {
        value() {
            this.selected = this._selecteds.includes(this.category._id);
        },
    },
};
</script>
